// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Copy = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M42.01,12.17v.92H9.02c-1.68,0-3.03,1.36-3.03,3.04v18.78h-.96c-1.68,0-3.04-1.36-3.04-3.04V12.17c0-1.68,1.36-3.04,3.04-3.04h33.95c1.68,0,3.03,1.36,3.03,3.04Z' />
      <path d='M46.01,16.13v19.7c0,1.68-1.36,3.04-3.04,3.04H9.02c-1.68,0-3.03-1.36-3.03-3.04v-19.7c0-1.68,1.35-3.04,3.03-3.04h33.95c1.68,0,3.04,1.36,3.04,3.04Z' />
    </svg>
  );
};
